function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import distributionRegionMixin from '@/mixins/distributionRegion';
import request from '@/utils/request';
import { fileImageApi } from '@/api/systemSetting';
import { openRegionAgent, getRegionAgent, getRegionQueue, enableFromQueue, handoverRegionAgent, getRegionAssignments, getAgentList, updateRegionAgent, disableRegionAgent, deleteRegionAgent, searchUser } from '@/api/distributionAlliance';
var cityListTree = function cityListTree() {
  return request({
    url: '/admin/merchant/city/region/city/tree',
    method: 'get'
  });
};
export default {
  mixins: [distributionRegionMixin],
  name: 'AllianceRegionAgent',
  data: function data() {
    return {
      loading: false,
      listLoading: false,
      saving: false,
      agentList: [],
      agentTotal: 0,
      // agentUid -> {nickname, phone, valid}，由列表接口一次性带回来
      agentUsers: {},
      uidChecking: false,
      listQuery: {
        regionPrefix: '',
        contact: '',
        includeInactive: false,
        page: 1,
        size: 20
      },
      // 级联选择器的选中路径，提交时只取末级编码当区域前缀
      listRegionIds: [],
      cityOptions: [],
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        checkStrictly: true,
        emitPath: true
      },
      regionCode: '',
      regionName: '',
      regionPath: '',
      agent: null,
      queue: [],
      assignments: [],
      agentDialog: false,
      // term 是 [开始, 结束] 的数组，提交时才拆成两个字段；留空即长期有效
      // 区域在弹窗里自己选：页面上方不再有全局的区域选择器
      agentForm: {
        regionIds: [],
        regionCode: '',
        regionName: '',
        regionPath: '',
        agentUid: undefined,
        contactName: '',
        contactPhone: '',
        term: null,
        // 开通资质。身份证号只上行不回显 —— 后端存的是密文，读回来是脱敏值
        companyName: '',
        licenseNo: '',
        licenseImage: '',
        legalPerson: '',
        idCardNo: '',
        idCardFront: '',
        idCardBack: ''
      },
      // 搜出来的候选用户，只服务于开通弹窗里的那个下拉
      userOptions: [],
      // 非空表示这次打开弹窗是「启用候补人」，提交走 enable 而不是 open
      queueEnableId: null,
      // 当前启用的这位候补人是否已经交过身份证号，决定上面那条校验能不能留空
      queueHasIdCard: false,
      editDialog: false,
      // contractNo / subsidyRatio 不在界面上，但要原样带回提交 ——
      // 不传的话后端会当成「清空」，把存量的合同号抹掉
      editForm: {
        id: null,
        regionCode: '',
        regionName: '',
        agentUid: null,
        agentName: '',
        contactName: '',
        contactPhone: '',
        contractNo: '',
        subsidyRatio: 0,
        term: null
      },
      agentRules: {
        regionCode: [{
          required: true,
          message: '请选择省/市/区',
          trigger: 'change'
        }],
        agentUid: [{
          required: true,
          message: '请搜索并选择代理账号',
          trigger: 'change'
        }],
        contactName: [{
          required: true,
          message: '请填写联系人',
          trigger: 'blur'
        }],
        contactPhone: [{
          required: true,
          message: '请填写联系方式',
          trigger: 'blur'
        }],
        companyName: [{
          required: true,
          message: '请填写企业名称',
          trigger: 'blur'
        }],
        licenseNo: [{
          required: true,
          message: '请填写统一社会信用代码',
          trigger: 'blur'
        }],
        licenseImage: [{
          required: true,
          message: '请上传营业执照',
          trigger: 'change'
        }],
        legalPerson: [{
          required: true,
          message: '请填写法人姓名',
          trigger: 'blur'
        }],
        // 留空是否合法要看场景，所以不能用静态的 required：启用候补人时申请人已经交过号，
        // 留空表示沿用，强制重填只会逼运营去别处找那串数字再抄一遍
        idCardNo: [{
          validator: this.validateIdCardNo,
          trigger: 'blur'
        }],
        idCardFront: [{
          required: true,
          message: '请上传身份证人像面',
          trigger: 'change'
        }]
      },
      handoverDialog: false,
      handoverForm: {
        regionCode: '',
        regionName: '',
        currentAgent: '',
        newAgentUid: undefined,
        reason: ''
      },
      handoverRules: {
        newAgentUid: [{
          required: true,
          message: '请搜索并选择新代理账号',
          trigger: 'change'
        }],
        reason: [{
          required: true,
          message: '请填写交接原因',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.loadCityTree();
    this.loadAgentList(1);
  },
  methods: {
    loadCityTree: function () {
      var _loadCityTree = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, list, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return cityListTree();
            case 1:
              res = _context.v;
              list = Array.isArray(res) ? res : res && res.list || [];
              this.cityOptions = this.normalizeTree(list);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadCityTree() {
        return _loadCityTree.apply(this, arguments);
      }
      return loadCityTree;
    }(),
    /**
     * 只保留省/市/区三级。城市树带第四级（街道/乡镇），
     * 而联盟的区域粒度到区县为止，多一级只会让人选出后端不认的编码。
     */
    normalizeTree: function normalizeTree(list) {
      var _this = this;
      var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (!Array.isArray(list)) return [];
      return list.map(function (n) {
        var children = n.child || n.children;
        var item = {
          id: String(n.regionId != null ? n.regionId : n.id),
          name: n.regionName || n.name
        };
        if (depth < 3 && Array.isArray(children) && children.length) {
          item.child = _this.normalizeTree(children, depth + 1);
        }
        return item;
      });
    },
    loadAgentList: function () {
      var _loadAgentList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(page) {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.listQuery.page = page || this.listQuery.page;
              this.listLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return getAgentList({
                regionPrefix: this.listQuery.regionPrefix || undefined,
                contact: this.listQuery.contact || undefined,
                includeInactive: this.listQuery.includeInactive,
                page: this.listQuery.page,
                size: this.listQuery.size
              });
            case 2:
              res = _context2.v;
              this.agentList = res && res.list || [];
              this.agentTotal = res && res.total || 0;
              this.agentUsers = res && res.users || {};
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.agentList = [];
              this.agentTotal = 0;
              this.agentUsers = {};
            case 4:
              _context2.p = 4;
              this.listLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function loadAgentList(_x) {
        return _loadAgentList.apply(this, arguments);
      }
      return loadAgentList;
    }(),
    onSizeChange: function onSizeChange(size) {
      this.listQuery.size = size;
      this.loadAgentList(1);
    },
    onListRegionChange: function onListRegionChange(value) {
      this.listQuery.regionPrefix = value && value.length ? value[value.length - 1] : '';
      this.loadAgentList(1);
    },
    resetAgentList: function resetAgentList() {
      this.listRegionIds = [];
      this.listQuery = {
        regionPrefix: '',
        contact: '',
        includeInactive: false,
        page: 1,
        size: 20
      };
      this.loadAgentList(1);
    },
    /**
     * activeKey 才是「是不是当前占着名额那条」，status 只说这条记录本身停没停用，
     * endTime 决定还能不能用 —— 三者合起来才是完整状态。
     *
     * 「已到期」和后端取生效代理时的时间判定是同一个口径：过期即代理端全部功能不可用，
     * 但记录还占着该区名额，所以它既不是「已停用」也不能算「生效」。
     */
    agentStatusText: function agentStatusText(row) {
      if (row.status !== 1) return '已停用';
      if (Number(row.activeKey) !== 0) return '历史';
      if (this.isExpired(row)) return '已到期';
      if (this.notStarted(row)) return '未开始';
      return '生效';
    },
    agentTagType: function agentTagType(row) {
      if (row.status !== 1) return 'info';
      if (Number(row.activeKey) !== 0) return 'info';
      if (this.isExpired(row)) return 'danger';
      if (this.notStarted(row)) return 'warning';
      return 'success';
    },
    /**
     * uid 在用户表里查不到时明确写出来。
     *
     * 这种记录是空壳：列表显示生效、分账也照算，但没有任何人能登录代理端，
     * 团长申请提交上去永远没人审批。不标出来运营根本发现不了。
     */
    agentName: function agentName(row) {
      var u = this.agentUsers[row.agentUid];
      if (!u) return '查无此人';
      if (!u.valid) return "".concat(u.nickname || '（未设昵称）', "\uFF08\u8D26\u53F7\u4E0D\u53EF\u7528\uFF09");
      return u.nickname || '（未设昵称）';
    },
    agentPhone: function agentPhone(row) {
      var u = this.agentUsers[row.agentUid];
      return u ? u.phone : '';
    },
    /**
     * 远程搜候选代理。keyword 是纯数字时后端会同时按 uid 精确匹配和手机号前缀试，
     * 所以运营手上只有 uid 也照样搜得到。
     */
    searchAgentUser: function () {
      var _searchAgentUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(keyword) {
        var res, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(!keyword || !keyword.trim())) {
                _context3.n = 1;
                break;
              }
              this.userOptions = [];
              return _context3.a(2);
            case 1:
              this.uidChecking = true;
              _context3.p = 2;
              _context3.n = 3;
              return searchUser(keyword.trim(), 10);
            case 3:
              res = _context3.v;
              this.userOptions = Array.isArray(res) ? res : [];
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              this.userOptions = [];
            case 5:
              _context3.p = 5;
              this.uidChecking = false;
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4, 5, 6]]);
      }));
      function searchAgentUser(_x2) {
        return _searchAgentUser.apply(this, arguments);
      }
      return searchAgentUser;
    }(),
    isExpired: function isExpired(row) {
      return !!row.endTime && new Date(row.endTime.replace(/-/g, '/')).getTime() < Date.now();
    },
    notStarted: function notStarted(row) {
      return !!row.startTime && new Date(row.startTime.replace(/-/g, '/')).getTime() > Date.now();
    },
    termText: function termText(row) {
      if (!row.startTime && !row.endTime) return '长期有效';
      return "".concat(row.startTime || '即时', " ~ ").concat(row.endTime || '长期');
    },
    termStart: function termStart(term) {
      return Array.isArray(term) && term.length === 2 ? term[0] : undefined;
    },
    termEnd: function termEnd(term) {
      return Array.isArray(term) && term.length === 2 ? term[1] : undefined;
    },
    openEditDialog: function openEditDialog(row) {
      this.editForm = {
        id: row.id,
        agentName: this.agentName(row),
        regionCode: row.regionCode,
        regionName: row.regionName,
        agentUid: row.agentUid,
        contactName: row.contactName || '',
        contactPhone: row.contactPhone || '',
        contractNo: row.contractNo || '',
        subsidyRatio: Number(row.subsidyRatio) || 0,
        term: row.startTime && row.endTime ? [row.startTime, row.endTime] : null
      };
      this.editDialog = true;
    },
    submitEdit: function () {
      var _submitEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.saving = true;
              _context4.p = 1;
              _context4.n = 2;
              return updateRegionAgent(this.editForm.id, {
                contractNo: this.editForm.contractNo,
                contactName: this.editForm.contactName,
                contactPhone: this.editForm.contactPhone,
                subsidyRatio: this.editForm.subsidyRatio,
                startTime: this.termStart(this.editForm.term),
                endTime: this.termEnd(this.editForm.term)
              });
            case 2:
              this.$message.success('已保存');
              this.editDialog = false;
              this.loadAgentList(this.listQuery.page);
              if (this.regionCode === this.editForm.regionCode) this.loadAll();
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
            case 4:
              _context4.p = 4;
              this.saving = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function submitEdit() {
        return _submitEdit.apply(this, arguments);
      }
      return submitEdit;
    }(),
    /**
     * 状态开关。只有「生效 → 停用」这一个方向，反向拨不回来 ——
     * 停用会腾出该区名额，这期间可能已经开了新代理。
     */
    onToggleStatus: function onToggleStatus(row) {
      this.onDisable(row);
    },
    onDelete: function () {
      var _onDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return this.$confirm("\u786E\u8BA4\u5220\u9664 ".concat(this.distributionRegionLabel(row.regionCode, row.regionName), " \u7684\u533A\u57DF\u4EE3\u7406\u8BB0\u5F55\uFF1F\u8BE5\u533A\u57DF\u672A\u7ED1\u5B9A\u56E2\u957F\uFF0C\u5220\u9664\u540E\u53EF\u91CD\u65B0\u5F00\u901A\u3002"), '提示', {
                type: 'warning'
              });
            case 1:
              _context5.n = 2;
              return deleteRegionAgent(row.id);
            case 2:
              this.$message.success('删除成功');
              this.loadAgentList(this.listQuery.page);
              if (this.regionCode === row.regionCode) this.loadAll();
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t5 = _context5.v;
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function onDelete(_x3) {
        return _onDelete.apply(this, arguments);
      }
      return onDelete;
    }(),
    onDisable: function () {
      var _onDisable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        var _t6, _t7;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return this.$confirm("\u786E\u8BA4\u505C\u7528 ".concat(this.distributionRegionLabel(row.regionCode, row.regionName), " \u7684\u4EE3\u7406\uFF1F") + '停用后该代理端全部功能立即不可用，该区名额释放，可重新开通或从候补队列启用。' + '历史分账记录不受影响。', '提示', {
                type: 'warning'
              });
            case 1:
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
              return _context6.a(2);
            case 3:
              _context6.p = 3;
              _context6.n = 4;
              return disableRegionAgent(row.id, '平台停用');
            case 4:
              this.$message.success('已停用');
              this.loadAgentList(this.listQuery.page);
              if (this.regionCode === row.regionCode) this.loadAll();
              _context6.n = 6;
              break;
            case 5:
              _context6.p = 5;
              _t7 = _context6.v;
            case 6:
              return _context6.a(2);
          }
        }, _callee6, this, [[3, 5], [0, 2]]);
      }));
      function onDisable(_x4) {
        return _onDisable.apply(this, arguments);
      }
      return onDisable;
    }(),
    /**
     * 从列表跳到下面的区域详情。
     *
     * 只填 regionCode/Name/Path，不回填上面的级联选择器 —— 那需要把编码反查成
     * 省市区三级 id 路径，城市树里没有现成的反查，为一个跳转做一份反查得不偿失。
     */
    viewRegion: function viewRegion(row) {
      var _this2 = this;
      this.regionCode = row.regionCode;
      this.regionName = row.regionName || '';
      this.regionPath = row.regionPath || '';
      this.loadAll();
      this.$nextTick(function () {
        var el = _this2.$el.querySelector('.agent-detail') || _this2.$el;
        if (el && el.scrollIntoView) el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    },
    viewLeaders: function viewLeaders(row) {
      var agentId = row && row.id;
      if (!agentId) {
        this.$message.warning('未找到代理记录，无法查看名下团长');
        return;
      }
      this.$router.push({
        name: 'allianceLeader',
        query: {
          agentId: String(agentId)
        }
      });
    },
    pathNames: function pathNames(ids) {
      var names = [];
      var level = this.cityOptions;
      ids.forEach(function (id) {
        var hit = (level || []).find(function (n) {
          return String(n.id) === String(id);
        });
        if (hit) {
          names.push(hit.name);
          level = hit.child;
        }
      });
      return names;
    },
    loadAll: function () {
      var _loadAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _yield$Promise$all, _yield$Promise$all2, agent, queue, assignments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (this.regionCode) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              this.loading = true;
              _context7.p = 2;
              _context7.n = 3;
              return Promise.all([getRegionAgent(this.regionCode).catch(function () {
                return null;
              }), getRegionQueue(this.regionCode).catch(function () {
                return [];
              }), getRegionAssignments(this.regionCode).catch(function () {
                return [];
              })]);
            case 3:
              _yield$Promise$all = _context7.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              agent = _yield$Promise$all2[0];
              queue = _yield$Promise$all2[1];
              assignments = _yield$Promise$all2[2];
              this.agent = agent && agent.id ? agent : null;
              this.queue = Array.isArray(queue) ? queue : [];
              this.assignments = Array.isArray(assignments) ? assignments : [];
            case 4:
              _context7.p = 4;
              this.loading = false;
              return _context7.f(4);
            case 5:
              return _context7.a(2);
          }
        }, _callee7, this, [[2,, 4, 5]]);
      }));
      function loadAll() {
        return _loadAll.apply(this, arguments);
      }
      return loadAll;
    }(),
    queueStatusText: function queueStatusText(s) {
      return {
        0: '候补中',
        1: '已启用',
        2: '已放弃',
        3: '已拒绝'
      }[s] || '-';
    },
    queueTagType: function queueTagType(s) {
      return {
        0: 'warning',
        1: 'success',
        2: 'info',
        3: 'danger'
      }[s] || 'info';
    },
    openAgentDialog: function openAgentDialog() {
      var _this3 = this;
      // 同区域允许多个代理；同账号同区域重复开通由后端及唯一索引校验。
      this.agentForm = {
        regionIds: [],
        regionCode: '',
        regionName: '',
        regionPath: '',
        agentUid: undefined,
        contactName: '',
        contactPhone: '',
        term: null,
        // 开通资质。身份证号只上行不回显 —— 后端存的是密文，读回来是脱敏值
        companyName: '',
        licenseNo: '',
        licenseImage: '',
        legalPerson: '',
        idCardNo: '',
        idCardFront: '',
        idCardBack: ''
      };
      this.userOptions = [];
      this.queueEnableId = null;
      this.queueHasIdCard = false;
      this.agentDialog = true;
      this.$nextTick(function () {
        return _this3.$refs.agentForm && _this3.$refs.agentForm.clearValidate();
      });
    },
    onAgentRegionChange: function onAgentRegionChange(ids) {
      if (!ids || !ids.length) {
        this.agentForm.regionCode = '';
        this.agentForm.regionName = '';
        this.agentForm.regionPath = '';
        return;
      }
      // regionCode 取末级 id，regionPath 是逗号分隔的整条 id 路径，与后端约定一致
      this.agentForm.regionCode = String(ids[ids.length - 1]);
      this.agentForm.regionPath = ids.join(',');
      this.agentForm.regionName = this.pathNames(ids).join('/');
    },
    submitOpen: function submitOpen() {
      var _this4 = this;
      this.$refs.agentForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(valid) {
          var _t8;
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.p = _context8.n) {
              case 0:
                if (valid) {
                  _context8.n = 1;
                  break;
                }
                return _context8.a(2);
              case 1:
                if (!_this4.queueEnableId) {
                  _context8.n = 2;
                  break;
                }
                return _context8.a(2, _this4.submitQueueEnable());
              case 2:
                _this4.saving = true;
                _context8.p = 3;
                _context8.n = 4;
                return openRegionAgent(_objectSpread({
                  regionCode: _this4.agentForm.regionCode,
                  regionName: _this4.agentForm.regionName,
                  regionPath: _this4.agentForm.regionPath,
                  agentUid: _this4.agentForm.agentUid,
                  contactName: _this4.agentForm.contactName,
                  contactPhone: _this4.agentForm.contactPhone,
                  startTime: _this4.termStart(_this4.agentForm.term),
                  endTime: _this4.termEnd(_this4.agentForm.term)
                }, _this4.qualificationPayload()));
              case 4:
                _this4.$message.success('开通成功');
                _this4.agentDialog = false;
                // 顺手把下方详情切到刚开通的这个区，省得再回列表点一次「查看」
                _this4.regionCode = _this4.agentForm.regionCode;
                _this4.regionName = _this4.agentForm.regionName;
                _this4.regionPath = _this4.agentForm.regionPath;
                _this4.loadAll();
                _this4.loadAgentList(1);
                _context8.n = 6;
                break;
              case 5:
                _context8.p = 5;
                _t8 = _context8.v;
              case 6:
                _context8.p = 6;
                _this4.saving = false;
                return _context8.f(6);
              case 7:
                return _context8.a(2);
            }
          }, _callee8, null, [[3, 5, 6, 7]]);
        }));
        return function (_x5) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    /**
     * 启用候补人。
     *
     * 走的是与平台招商同一个开通入口，所以同样要有资质。申请人在小程序端提交申请时
     * 就把资质交齐了，这里直接回填，不用照着截图再敲一遍；要改哪一项就地改即可。
     *
     * 身份证号例外：接口回的是脱敏值（1101***********234），回填进去再提交等于
     * 把这串星号当成新号码存回库里。所以留空并提示「不填沿用申请人提交的」——
     * 后端认这个口径：空值或带 * 的值一律沿用候补记录里的密文。
     */
    onEnable: function onEnable(row) {
      var _this5 = this;
      this.queueEnableId = row.id;
      this.agentForm = {
        regionIds: [],
        regionCode: row.regionCode || this.regionCode,
        regionName: row.regionName || this.regionName,
        regionPath: this.regionPath,
        agentUid: row.applicantUid,
        contactName: row.realName || '',
        contactPhone: row.phone || '',
        term: null,
        companyName: row.companyName || '',
        licenseNo: row.licenseNo || '',
        licenseImage: row.licenseImage || '',
        legalPerson: row.legalPerson || '',
        idCardNo: '',
        idCardFront: row.idCardFront || '',
        idCardBack: row.idCardBack || ''
      };
      // 申请人交过身份证号时不再强制重填：留空即沿用，规则与后端一致
      this.queueHasIdCard = !!row.idCardNo;
      // 候选下拉是远程搜出来的，直接塞一条进去，否则回显是个光秃秃的 uid
      this.userOptions = [{
        uid: row.applicantUid,
        nickname: row.applicantName || '候补申请人',
        phone: '',
        valid: true
      }];
      this.agentDialog = true;
      this.$nextTick(function () {
        return _this5.$refs.agentForm && _this5.$refs.agentForm.clearValidate();
      });
    },
    submitQueueEnable: function () {
      var _submitQueueEnable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _t9;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              this.saving = true;
              _context9.p = 1;
              _context9.n = 2;
              return enableFromQueue(this.queueEnableId, this.regionPath, this.qualificationPayload());
            case 2:
              this.$message.success('已启用');
              this.agentDialog = false;
              this.queueEnableId = null;
              this.loadAll();
              this.loadAgentList(1);
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t9 = _context9.v;
            case 4:
              _context9.p = 4;
              this.saving = false;
              return _context9.f(4);
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this, [[1, 3, 4, 5]]);
      }));
      function submitQueueEnable() {
        return _submitQueueEnable.apply(this, arguments);
      }
      return submitQueueEnable;
    }(),
    /**
     * 身份证号校验。平台招商开通必须填；启用候补人时申请人已经交过，
     * 留空表示沿用候补记录里的密文（后端认这个口径）。
     */
    validateIdCardNo: function validateIdCardNo(rule, value, callback) {
      var text = (value || '').trim();
      if (!text) {
        return this.queueEnableId && this.queueHasIdCard ? callback() : callback(new Error('请填写法人身份证号'));
      }
      return /^[0-9]{17}[0-9Xx]$/.test(text) ? callback() : callback(new Error('身份证号格式不正确'));
    },
    /** 资质字段平铺进请求体，开通与启用候补人共用 */qualificationPayload: function qualificationPayload() {
      return {
        companyName: this.agentForm.companyName,
        licenseNo: this.agentForm.licenseNo,
        licenseImage: this.agentForm.licenseImage,
        legalPerson: this.agentForm.legalPerson,
        idCardNo: this.agentForm.idCardNo,
        idCardFront: this.agentForm.idCardFront,
        idCardBack: this.agentForm.idCardBack
      };
    },
    /** 证件照上传。只存地址，图片本身在对象存储里 */uploadCert: function uploadCert(param, field) {
      var _this6 = this;
      var formData = new FormData();
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading'
      });
      fileImageApi(formData, {
        model: 'alliance',
        pid: 0
      }).then(function (res) {
        _this6.agentForm[field] = res.url;
        // 图片是 change 触发校验的，手动清一下这一项的红字
        _this6.$refs.agentForm && _this6.$refs.agentForm.clearValidate(field);
      }).catch(function () {}).finally(function () {
        return loading.close();
      });
    },
    openHandoverDialog: function openHandoverDialog(row) {
      var _this7 = this;
      // 区域从行上带，不再依赖下方详情选中的那个区
      this.handoverForm = {
        regionCode: row.regionCode,
        regionName: row.regionName || '',
        currentAgent: this.agentName(row),
        newAgentUid: undefined,
        reason: ''
      };
      // 两个弹窗共用这一份候选，开之前清掉，免得带着上次开通时搜的人
      this.userOptions = [];
      this.handoverDialog = true;
      this.$nextTick(function () {
        return _this7.$refs.handoverForm && _this7.$refs.handoverForm.clearValidate();
      });
    },
    submitHandover: function submitHandover() {
      var _this8 = this;
      this.$refs.handoverForm.validate(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(valid) {
          var _t0;
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.p = _context0.n) {
              case 0:
                if (valid) {
                  _context0.n = 1;
                  break;
                }
                return _context0.a(2);
              case 1:
                _this8.saving = true;
                _context0.p = 2;
                _context0.n = 3;
                return handoverRegionAgent({
                  regionCode: _this8.handoverForm.regionCode,
                  newAgentUid: _this8.handoverForm.newAgentUid,
                  reason: _this8.handoverForm.reason,
                  // 待结算金额不再由页面填。后端拿它做「未结清不允许交接」的判定，
                  // 传 0 等于这道判定不生效 —— 代理侧没有余额表，前端拿不到真实数字，
                  // 让人手填反而更糟：填错就是绕过校验，还留下一条像是核对过的记录。
                  // 补上 §8.4 的代理账户表后改成后端自己算，不再走入参
                  pendingSettleAmount: 0
                });
              case 3:
                _this8.$message.success('交接完成');
                _this8.handoverDialog = false;
                _this8.loadAgentList(_this8.listQuery.page);
                if (_this8.regionCode === _this8.handoverForm.regionCode) _this8.loadAll();
                _context0.n = 5;
                break;
              case 4:
                _context0.p = 4;
                _t0 = _context0.v;
              case 5:
                _context0.p = 5;
                _this8.saving = false;
                return _context0.f(5);
              case 6:
                return _context0.a(2);
            }
          }, _callee0, null, [[2, 4, 5, 6]]);
        }));
        return function (_x6) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }
};